export default {
      id: "folder-usage",
      viewBox: "0 0 13.045 10.09",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#folder",
      toString: function () {
        return this.url;
      }
    }